import { render } from "./PpcBAProductInfoCell.vue?vue&type=template&id=5fa2d137&scoped=true"
import script from "./PpcBAProductInfoCell.vue?vue&type=script&lang=js"
export * from "./PpcBAProductInfoCell.vue?vue&type=script&lang=js"

import "./PpcBAProductInfoCell.vue?vue&type=style&index=0&id=5fa2d137&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fa2d137"]])

export default __exports__